import React from 'react'
import { ButtonProps } from './types'
import { Tooltip } from 'app/modules/reports/components/tooltip'
import kebabCase from 'lodash/kebabCase'

// General button component
const Button = React.forwardRef((props: ButtonProps, ref) => {
  const { children, className, variant = 'primary', tooltip, tooltipPlacement, type, id, ...other } = props
  const baseClass = variant === 'plain' ? 'unstyled-button' : `btn btn-${variant}`
  const fullClass = `${baseClass} ${other.disabled ? 'disabled' : ''} ${className || ''}`
  const buttonId = `btn-${kebabCase(id)}`

  const button = (
    <button id={buttonId} type={type ?? 'button'} className={fullClass} ref={ref as any} {...other}>
      {children}
    </button>
  )

  return tooltip ? (
    <Tooltip content={tooltip} placement={tooltipPlacement} id={`tooltip-${buttonId}`}>
      {button}
    </Tooltip>
  ) : (
    button
  )
})

export default Button
